import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { CapabilityEngineService } from '../capabilityEngine.service';
import { RedirectService } from '../redirect/redirect.service';
import { SubmittedFormsService } from './submitted-forms.service';

@Component({
    selector: 'app-submitted-forms',
    templateUrl: './submitted-forms.component.html',
    styleUrls: ['./submitted-forms.component.scss']
})
export class SubmittedFormsComponent implements OnInit {

    submittedFormsList: any;
    pageNumber: number = 0;
    date: Date;
    sortKey: String;
    sortOrder: String;
    mainDirectoryTemplates: any = [];
    subFormArray: any = [];
    directoryList = false;
    collectionName;
    constructor(
        private _submittedFormsService: SubmittedFormsService,
        private _capabilityEngineService: CapabilityEngineService,
        private _redirectService: RedirectService,
        private _activatedRoute: ActivatedRoute,
        private _router: Router
    ) { }

    ngOnInit() {
        const pathData = this._activatedRoute.data['_value'];
        if (this.canPerform(pathData.capabilities)) {
            this.onScroll();
        }
    }

    sort(key) {
        if (key === this.sortKey) {
            this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
        } else {
            this.sortKey = key;
            this.sortOrder = 'asc';
        }
    }

    canPerform(data) {
        return this._capabilityEngineService.canPerform(data);
    }
    nameSort(formList) {
        let statusZero: any = _.filter(formList, function (o) { return o.status === 0 });
        statusZero.sort((a, b) => a.name.localeCompare(b.name));
        let statusOne = _.filter(formList, function (o) { return o.status === 2 });
        _.forEach(statusOne, (value, key) => {
            statusZero.push(value)
        });
        return statusZero;
    }


    onScroll() {
        this._submittedFormsService.performPagination(this.pageNumber)
            .subscribe((result: any) => {
                if (this.mainDirectoryTemplates.length === 0) {
                    this.mainDirectoryTemplates.push({ templates: _.filter(result.data, function (o) { return !o.directory; }), directory: _.filter(result.data, function (o) { return o.directory; }) });
                    if (!this.submittedFormsList) {
                        this.submittedFormsList = this.mainDirectoryTemplates[0].templates;
                        console.log(this.submittedFormsList, 'submittedFormList');

                        this._submittedFormsService.getTemplateDirecotries().subscribe(
                            (res: any) => {
                                console.log(res, 'directories');

                                if (!this.submittedFormsList.type) {
                                    _.forEach(res.data, (val, key) => {
                                        this.submittedFormsList.push({ _id: val._id, name: val.name, type: 'folder', updatedBy: {}, status: 0 });
                                    });
                                    this.submittedFormsList = this.nameSort(this.submittedFormsList);
                                }
                            },
                            (err) => {
                                console.log(err, 'err');
                            });
                        if (this.submittedFormsList) {
                            const publishedForms = [];
                            _.map(this.submittedFormsList, (form) => { if (form.status === 0) { publishedForms.push(form) } });
                        }
                    } else {
                        this.submittedFormsList = _.union(this.submittedFormsList, this.mainDirectoryTemplates[0].templates);
                    }
                }
                // console.log(result, this.submittedFormsList);
                // if (!this.submittedFormsList) {
                //     this.submittedFormsList = result.data;
                // } else {
                //     this.submittedFormsList = _.union(this.submittedFormsList, result.data);
                // }
                // this.pageNumber++;
            });
    }

    downloadRawData() {
        this._submittedFormsService.getRawData();
    }

    getFirstLetterString(name) {
        let result = '';
        let splitArray = name.split(' ');
        if (name.length === 1) {
            result = name;
        }
        else if (splitArray.length === 1) {
            result = splitArray[0][0] + splitArray[0][1];
        } else {
            _.forEach(splitArray, function (word) {
                result = result.concat(word[0]);
            });
        }
        return result.substring(0, 2);
    }
    getBase64String(str) {
        return 'data:image/jpg;base64,' + str;
    }

    backtoTemplate() {
        this.directoryList = false;
    }
    navigateSubmiitedFormsList(type, templateForm) {
        let redirectUrl = "";
        let userRole = localStorage.getItem("userRole");
        if(userRole && (userRole === "supervisor" || userRole === "webAdmin")) {
            let teams = JSON.parse(localStorage.getItem("teams"))
            let operators = [];
            if(teams && teams.length > 0) {
                let presentTeamId = localStorage.getItem("teamId")
                let presentTeamIndex = _.findIndex(teams, {teamDetails: {"_id": presentTeamId}})
                if(presentTeamIndex != -1) {
                    let presentTeamOperators = teams[presentTeamIndex]['operators'];
                    if(presentTeamOperators && presentTeamOperators.length > 0) {
                        operators = _.map(presentTeamOperators, (operator) => {
                            return {
                                _id: operator['_id'],
                                name: operator['name']
                            }
                        })
                    }
                }
            }
            if(operators && operators.length > 0) {
                redirectUrl = this.prepareUrlForOptedOperators(operators)
            }
        }
        if (type) {
            this.collectionName = templateForm.name;
            this.subFormArray = [];
            if (this.subFormArray.length === 0) {
                _.map(this.mainDirectoryTemplates[0].directory, (form) => {
                    if (form.directory && form.directory._id && form.directory._id === templateForm._id) {
                        this.subFormArray.push(form);
                        this.subFormArray = this.nameSort(this.subFormArray);
                    }
                });
            }
            this.directoryList = true;
        } else {
            let uri = ""
            if (templateForm.displayFields.length > 1) {
                if (templateForm.status === 2) {
                    uri = '/submittedFormList/' + templateForm._id + '?formName=' + templateForm.name + '&key=' + templateForm.displayFields[1] + '&display=' + templateForm.displayFields[0] + '&isActive=' + false + redirectUrl;
                } else {
                    uri = '/submittedFormList/' + templateForm._id + '?formName=' + templateForm.name + '&key=' + templateForm.displayFields[1] + '&display=' + templateForm.displayFields[0] + redirectUrl;
                }
            } else {
                if (templateForm.status === 2) {
                   uri = '/submittedFormList/' + templateForm._id + '?formName=' + templateForm.name + '&isActive=' + false + redirectUrl;
                } else {
                   uri = '/submittedFormList/' + templateForm._id + '?formName=' + templateForm.name + redirectUrl;
                }
            }

            this._router.navigateByUrl(uri);
        }
    }

    isFormhound(){
        return this._capabilityEngineService.isFormhound();
    }

    prepareUrlForOptedOperators(users) {
        let url = '';
        _.forEach(users, user => {
            url = url.concat("&uid=" + user._id);
            url = url.concat(
                "&" + user._id + "=" + encodeURI(user.name)
            );
        });
        if(url && url.length > 0) {
            return `&filter=true${url}`;
        }
        return '';
    }
}




// WEBPACK FOOTER //
// ./src/app/submitted-forms/submitted-forms.component.ts